/**
 * Reads the current repo's "name with owner" from the
 * `<meta name="current-repo-nwo">` tag, if present.
 * Returns `null` when the tag is missing, malformed, or `document` is unavailable (SSR).
 */
export function getCurrentOwnerRepo(): {owner: string; repo: string} | null {
  if (typeof document === 'undefined') return null
  const meta = document.querySelector('meta[name="current-repo-nwo"]')
  const content = meta?.getAttribute('content')
  if (!content) return null
  const parts = content.split('/')
  if (parts.length !== 2) return null
  const [owner, repo] = parts
  if (!owner || !repo) return null
  return {owner, repo}
}
